import { Box, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { appVersion } from '../../configs/app';

const iconButtonSx = {
    width: 52,
    height: 52,
    borderRadius: 1.5,
    color: '#D63731'
};

const iconImageSx = {
    width: 31,
    height: 31,
    display: 'block'
};

const DashboardHeader = ({
    userName,
    onLogout,
    onBrandClick,
    onProfileClick,
    onSettingsClick,
    onNotificationsClick,
    hasUnreadNotifications = false,
    hasNewNotificationArrival = false,
    notificationsOpen = false,
    canAccessSettings = false
}) => {
    return (
        <Paper
            sx={{
                px: { xs: 2, md: 3.5 },
                py: { xs: 1, md: 1.1 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                bgcolor: '#fff',
                borderRadius: 0,
                border: 'none',
                boxShadow: '0px 2px 8px rgba(61, 61, 61, 0.08)'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 2, md: 5 } }}>
                <Typography
                    onClick={onBrandClick}
                    sx={{
                        cursor: onBrandClick ? 'pointer' : 'default',
                        color: '#D63731',
                        fontWeight: 700,
                        letterSpacing: '-0.02em',
                        fontSize: { xs: '1.2rem', md: '1.32rem' },
                        lineHeight: 1
                    }}
                >
                    INFO.CUIDADOR 2.0
                </Typography>
                <Typography
                    sx={{
                        fontWeight: 700,
                        color: '#111',
                        fontSize: { xs: '1.2rem', md: '1.32rem' },
                        lineHeight: 1,
                        letterSpacing: '-0.03em'
                    }}
                >
                    Bom dia {userName || 'Utilizador'}
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.75, md: 1.25 } }}>
                {/* Future actions kept prepared for later implementation.
                <Box
                    sx={{
                        px: 2.5,
                        py: 1.4,
                        borderRadius: 2.5,
                        bgcolor: '#fff',
                        border: '1px solid #ECECEC',
                        boxShadow: '0px 2px 8px rgba(61, 61, 61, 0.10)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        color: '#3D3D3D',
                        fontSize: '0.95rem',
                        fontWeight: 500
                    }}
                >
                    <Box component="img" src="/assets/logos-svg/comunication.svg" alt="" sx={{ width: 28, height: 28 }} />
                    Comunicado Geral
                </Box>
                <IconButton size="small" sx={iconButtonSx}>
                    <Box component="img" src="/assets/logos-svg/chat.svg" alt="Chat" sx={iconImageSx} />
                </IconButton>
                <IconButton size="small" sx={iconButtonSx}>
                    <Box component="img" src="/assets/logos-svg/team.svg" alt="Calendário" sx={iconImageSx} />
                </IconButton>
                */}

                <Typography
                    variant="caption"
                    sx={{
                        mr: 0.5,
                        userSelect: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        lineHeight: 1,
                        color: '#7A7A7A',
                        fontSize: '1rem',
                        fontWeight: 500
                    }}
                >
                    v{appVersion}
                </Typography>
                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                    <Tooltip title="Ver notificações recentes">
                        <IconButton
                            size="small"
                            onClick={onNotificationsClick}
                            sx={{
                                ...iconButtonSx,
                                animation: hasNewNotificationArrival
                                    ? 'notificationPulse 1.2s ease-in-out 2'
                                    : 'none',
                                '@keyframes notificationPulse': {
                                    '0%': { transform: 'scale(1)' },
                                    '40%': { transform: 'scale(1.08)' },
                                    '100%': { transform: 'scale(1)' }
                                }
                            }}
                        >
                            <Box
                                component="img"
                                src={
                                    notificationsOpen
                                        ? '/assets/logos-svg/notificationsAlert.svg'
                                        : '/assets/logos-svg/notifications.svg'
                                }
                                alt="Notificações"
                                sx={iconImageSx}
                            />
                        </IconButton>
                    </Tooltip>
                    {hasNewNotificationArrival ? (
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 4,
                                right: -8,
                                px: 0.9,
                                minWidth: 34,
                                height: 20,
                                borderRadius: '999px',
                                bgcolor: '#D63731',
                                color: '#FFFFFF',
                                border: '2px solid #FFFFFF',
                                boxShadow: '0px 4px 12px rgba(214, 55, 49, 0.24)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '0.65rem',
                                fontWeight: 800,
                                lineHeight: 1,
                                letterSpacing: '0.02em'
                            }}
                        >
                            Nova
                        </Box>
                    ) : hasUnreadNotifications ? (
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                bgcolor: '#D63731',
                                border: '2px solid #FFFFFF',
                                boxShadow: '0px 0px 0px 3px rgba(214, 55, 49, 0.12)'
                            }}
                        />
                    ) : null}
                </Box>
                {canAccessSettings ? (
                    <Tooltip title="Abrir definições da plataforma">
                        <IconButton size="small" onClick={onSettingsClick} sx={iconButtonSx}>
                            <Box
                                component="img"
                                src="/assets/logos-svg/settings.svg"
                                alt="Definições"
                                sx={{
                                    ...iconImageSx,
                                    width: 25,
                                    height: 25
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                ) : null}
                <Tooltip title="Abrir perfil pessoal">
                    <IconButton size="small" onClick={onProfileClick} sx={iconButtonSx}>
                        <Box component="img" src="/assets/logos-svg/myprofile.svg" alt="Meu perfil" sx={iconImageSx} />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Terminar sessão">
                    <IconButton size="small" onClick={onLogout} sx={iconButtonSx}>
                        <Box component="img" src="/assets/logos-svg/logout.svg" alt="Logout" sx={iconImageSx} />
                    </IconButton>
                </Tooltip>
            </Box>
        </Paper>
    );
};

export default DashboardHeader;
